
import { makeStyles } from 'tss-react/mui';
import EDIconButton from '../../../../../../../../BaseComponents/Buttons/IconButton/EDIconButton';
import EDListItem from '../../../../../../../../BaseComponents/List/Components/EDListItem';
import EDTypography from '../../../../../../../../BaseComponents/Typography/EDTypography';
import { AttestantQuery_node_TEDLRAttestant__Associations_Reserver_All } from '../../../Queries/_QueryTypes/AttestantQuery';
import {
  ReservForQuery_db_LRAttestrattReserv_All,
  ReservForQuery_db_LRAttestrattReserv_All__Associations_Attestratt__Associations,
} from '../../ReservFor/Queries/_QueryTypes/ReservForQuery';

interface IReservProps {
  isAuto: boolean;
  deleteClick?: (event: React.MouseEvent<HTMLElement>) => void;
  onEditClick?: (event: React.MouseEvent<HTMLElement>) => void;
  isCertifier?: boolean;
  isSmallScreen: boolean;
  level: number;
  pointer: string | null;
  standIn:
    | AttestantQuery_node_TEDLRAttestant__Associations_Reserver_All
    | ReservForQuery_db_LRAttestrattReserv_All;
  isReservFor?: boolean;
  index: number;
}

// TODO jss-to-tss-react codemod: Unable to handle style definition reliably. ArrowFunctionExpression in CSS prop.
// TODO jss-to-tss-react codemod: Unable to handle style definition reliably. ArrowFunctionExpression in CSS prop.
// TODO jss-to-tss-react codemod: Unable to handle style definition reliably. ArrowFunctionExpression in CSS prop.
// TODO jss-to-tss-react codemod: Unable to handle style definition reliably. ArrowFunctionExpression in CSS prop.
// TODO jss-to-tss-react codemod: Unable to handle style definition reliably. ArrowFunctionExpression in CSS prop.
// TODO jss-to-tss-react codemod: Unable to handle style definition reliably. ArrowFunctionExpression in CSS prop.
const useStyles = makeStyles<IReservProps>()((theme, props) => ({
  container: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    display: 'flex',
    flexFlow: 'row nowrap',
    width: '100%',
    paddingLeft: `${8 * props.level + 8}px`,
    fontStyle: `${props.isAuto ? 'italic' : 'normal'}`,
    borderLeft: props.isAuto ? '4px solid lightgray' : '',

    ['&:last-child']: { borderBottom: 'none' },
  },
  item: {
    width: 'calc(100% / 3 - 48px / 3)',
    ['&:last-child']: { width: '48px' },
  },

  containerSmall: {
    display: 'flex',
    flexFlow: 'row nowrap',
    justifyContent: 'space-between',
    borderBottom: `1px solid ${theme.palette.divider}`,
    paddingLeft: `${8 * props.level + 8}px`,
    fontStyle: `${props.isAuto ? 'italic' : 'normal'}`,
    borderLeft: props.isAuto ? '4px solid lightgray' : '',

    ['&:last-child']: { borderBottom: 'none' },
  },

  itemSmall: {
    width: '100%',
    ['&:last-child']: { width: '48px' },
  },

  pointer: { cursor: 'pointer' },
}));

const ReservListItem: React.FC<
  React.PropsWithChildren<IReservProps>
> = props => {
  const { classes, cx } = useStyles(props);

  const standInNote = props.standIn.NOTERING
    ? props.standIn.NOTERING?.length > 30
      ? props.standIn.NOTERING?.substring(0, 30) + '...'
      : props.standIn.NOTERING
    : '';

  const label = props.isAuto ? 'Delegerad från: ' : 'Notering: ';

  const delegeradFrom = props.standIn.DelegeradFranPath?.split(',') ?? [];

  const isReservOrReservForLabel = props.isReservFor
    ? 'Reserv för: '
    : 'Reserv: ';

  const note = props.isAuto
    ? delegeradFrom[delegeradFrom?.length - 1]
    : standInNote;

  const pointer = props.isAuto
    ? null
    : props.isCertifier && !props.isReservFor
    ? props.pointer
    : null;

  const itemClass = props.isSmallScreen ? classes.itemSmall : classes.item;

  const listItemContent = (
    <>
      <span className={itemClass}>
        <EDTypography
          color={props.isAuto && props.isReservFor ? 'secondary' : undefined}
          bold={!props.isCertifier || props.isReservFor}
        >
          Frånvaroperiod:
        </EDTypography>
        <EDTypography
          color={
            props.isAuto
              ? 'secondary'
              : props.isCertifier
              ? 'primary'
              : undefined
          }
          bold={props.isCertifier}
          onClick={props.isAuto ? undefined : props.onEditClick}
          className={cx([pointer])}
        >
          {`${props.standIn.DATUM_FROM} - ${props.standIn.TomDatumStr ?? ''}`}
        </EDTypography>
      </span>
      <span className={itemClass}>
        <EDTypography>
          <EDTypography
            bold
            color={props.isAuto ? 'secondary' : undefined}
            component="span"
          >
            {isReservOrReservForLabel}
          </EDTypography>
          {props.isReservFor
            ? (
                props.standIn._Associations?.Attestratt
                  ?._Associations as ReservForQuery_db_LRAttestrattReserv_All__Associations_Attestratt__Associations
              )?.Attestant?.BENAMNING
            : props.standIn._Associations?.Reserv?._Associations?.Attestant
                ?.BENAMNING}
        </EDTypography>
      </span>
      <span className={itemClass}>
        <EDTypography>
          <EDTypography
            bold
            color={props.isAuto ? 'secondary' : undefined}
            component="span"
          >
            {label}
          </EDTypography>
          {note}
        </EDTypography>
      </span>
    </>
  );

  return (
    <EDListItem
      className={
        props.isSmallScreen ? classes.containerSmall : classes.container
      }
      testId={`absence-list-item-${props.index}`}
    >
      {props.isSmallScreen ? <span>{listItemContent}</span> : listItemContent}
      <span className={itemClass}>
        {!props.isAuto && props.deleteClick && (
          <EDIconButton
            margin="none"
            icon="delete"
            tooltip="Ta bort frånvaroperiod"
            onClick={props.deleteClick}
          />
        )}
      </span>
    </EDListItem>
  );
};

export default ReservListItem;
